<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19.89 18.55l-2.53-5.06a7 7 0 10-10.72 0l-2.53 5.06A1 1 0 005 20h2.59l1.7 1.71A1 1 0 0010 22h.16a1 1 0 00.73-.54L12 19.24l1.11 2.21a1 1 0 00.73.54H14a1 1 0 00.71-.29l1.7-1.7H19a1 1 0 00.89-1.45zm-10.16.76l-1-1A1 1 0 008 18H6.62l1.57-3.14a6.93 6.93 0 002.08.91l.61 1.23zM7 9a5 5 0 115 5 5 5 0 01-5-5zm9 9a1 1 0 00-.71.29l-1 1L12.6 16a6.85 6.85 0 003.21-1.11L17.38 18z"/><path d="M13.79 6.79l-2.29 2.3-1.29-1.3a1 1 0 10-1.42 1.42l2 2a1 1 0 001.42 0l3-3a1 1 0 10-1.42-1.42z"/></svg>